import {
  FETCH_ALL_MESSAGE_TEMPLATE_TYPES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_MESSAGE_TEMPLATE_TYPES](state, types) {
    state.types = types;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/messageTemplateType/mutations.js